import { render, staticRenderFns } from "./NewChannelAgent.vue?vue&type=template&id=7294f884&scoped=true&"
import script from "./NewChannelAgent.vue?vue&type=script&lang=js&"
export * from "./NewChannelAgent.vue?vue&type=script&lang=js&"
import style0 from "./NewChannelAgent.vue?vue&type=style&index=0&id=7294f884&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294f884",
  null
  
)

export default component.exports